module.exports = new __parcel__URL__("Marketing Campaign.496d08ac.svg").toString();